import type { QuestionGroup } from './types';

export const GROUP_DEFINITIONS: QuestionGroup[] = [
  {
    id: 'identity',
    title: 'What is your gender identity and orientation?',
    keys: ['A5', 'A6'],
    hideTitles: true,
    aggregateCount: false,
  },
  {
    id: 'coop-role-ce',
    title: 'Role by term (Computer Engineering)',
    keys: ['B1','B2-ce','B3-ce','B4-ce','B5-ce','B6-ce'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
  },
  {
    id: 'coop-role-ee',
    title: 'Role by term (Electrical Engineering)',
    keys: ['B2','B2-ee','B3-ee','B4-ee','B5-ee','B6-ee'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
  },
  {
    id: 'coop-languages',
    title: 'Languages used by term',
    keys: ['B13','B14','B15','B16','B17','B18'],
    perTermToggle: true,
  },
  {
    id: 'coop-rating',
    title: 'Co-op rating by term',
    keys: ['B19','B20','B21','B22','B23','B24'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
  },
  {
    id: 'coop-return-offer',
    title: 'Return offer by term',
    keys: ['B25','B26','B27','B28','B29','B30'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    commentaryHtml: `
    <p>60% of students received at least one full-time return offer across any co-op term.</p>
    `
  },
  {
    id: 'coop-recruitment',
    title: 'Recruitment event by term',
    keys: ['B31','B32','B33','B34','B35','B36'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    commentaryHtml: `
    <p>36% of students found a co-op by applying externally for at least one of their co-op terms.</p>
    `
  },
  {
    id: 'mental-health-supports',
    title: '',
    keys: ['A26-used', 'A26-kinds'],
    aggregateCount: false,
  },
  {
    id: 'habits',
    title: 'On average during academic terms...',
    keys: ['A14', 'A15', 'A16', 'A17', 'A18', "A20", "A21"],
    aggregateCount: true,
    showResponses: true,
    responseCountMode: 'max'
  },
  {
    id: 'never-have-i-ever',
    title: 'Never Have I Ever...',
    keys: [
      'A38','A39','A40','A41','A42','A43','A44','A45','A46','A47','A48','A49','A50','A51','A52','A53','A54','A55','A56','A57','A58','A59','A60','A61','A62','A63','A64','A72','A73','A74','A75'
    ],
    aggregateCount: true,
    showResponses: true,
    responseCountMode: 'max'
  },
    {
    id: 'friends',
    title: 'Friendships',
    keys: ['A67', 'A68', 'A69'],
    aggregateCount: true,
    showResponses: true,
    responseCountMode: 'max',
    commentaryHtml: `
    <p>In first two graphs, respondents rated their answer from 1 (strong disagreement) to 5 (strong agreement). 76.6% agreed that they made close friends in the program. All engineering classes at UW are placed into cohorts: you take the same courses and co-op sequence as the rest of your cohort for most of your degree. The cohort system is often touted as a key benefit over non-eng programs: the people around you really make the experience!</p>
    `
  },
  {
    id: 'coop-compensation',
    title: 'Co-op Hourly Compensation by Term',
    keys: ['B37', 'B38', 'B39', 'B40', 'B41', 'B42'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
  },
  {
    id: 'coop-location',
    title: 'Co-op Locations by Term',
    keys: ['B7', 'B8', 'B9', 'B10', 'B11', 'B12'],
    flowKey: 'B-coop-location-flow',
    stacked: true,
  },
  {
    id: 'coop-companies',
    title: 'What company did you work at?',
    keys: ['B43','B44','B45','B46','B47','B48'],
    perTermToggle: true,
    hideTitles: true,
    showResponses: true,
    aggregateCount: true,
  },
  {
    id: 'expenses',
    title: 'In total, what proportion of your expenses on academic terms did you pay for yourself?',
    keys: ['B60', 'B61', 'B62'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    labels: ["Tuition", "Rent", "Living Expenses"]
  },
  {
    id: 'term-challenge',
    title: 'How challenging did you find each term?',
    keys: ['B69', 'B70', 'B71', 'B72', 'B73', 'B74', 'B75', 'B76'],
    labels: ['1A', '1B', '2A', '2B', '3A', '3B', '4A', '4B'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    commentaryHtml: '<p>2A was the most challenging term, and 4B was the lightest. From 2B onward students get more and more elective slots.</p>',
  },
  {
    id: 'term-enjoyment',
    title: 'How much did you enjoy each term?',
    keys: ['B77', 'B78', 'B79', 'B80', 'B81', 'B82', 'B83', 'B84'],
    labels: ['1A', '1B', '2A', '2B', '3A', '3B', '4A', '4B'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    commentaryHtml: '<p>1A was the least enjoyable term, and 4B was the most liked. Online learning during COVID was not fun, but enjoyment improved term by term!</p>',
  },
  
  {
    id: 'failing',
    title: 'Did you ever fail a...',
    keys: ['B86', 'B87', 'B88', 'B89'],
    stacked: true,
    showResponses: true,
    responseCountMode: 'max',
    labels: ["Midterm", "Final", "Course", "Term"]
  },
  {
    id: 'interviews',
    title: '',
    keys: ['B50', 'B49', 'B52', 'B53'],
    aggregateCount: true,
  },
  {
    id: 'side-gig',
    title: '',
    keys: ['B51-used', 'B51-kinds'],
    aggregateCount: true,
    showResponses: true,
  },
  {
    id: 'ft-total-compensation',
    title: 'Full-time Total Compensation',
    keys: ['B134', 'B131', 'B133'],
    perTermToggle: true,
    chipLabels: ['All (CAD)', 'Canada (CAD)', 'US (USD)'],
  },
  {
    id: 'ft-compensation-breakdown',
    title: 'Full-time Compensation Breakdown',
    keys: ['B134', 'B115', 'B116', 'B117', 'B131', 'B135', 'B137', 'B139', 'B133', 'B136', 'B138', 'B140'],
    chipPair: {
      geoLabels: ['All (CAD)', 'Canada (CAD)', 'US (USD)'],
      viewLabels: ['Total Compensation', 'Breakdown'],
      keyGroups: [
        ['B134',  'B115',  'B116',  'B117'],
        ['B131',  'B135',  'B137',  'B139'],
        ['B133',  'B136',  'B138',  'B140'],
      ],
    },
    commentary: 'USD to CAD was converted at 1.37.',
  },
  {
    id: 'rescind',
    title: '',
    keys: ['B52', 'B53'],
    aggregateCount: true,
  },
  {
    id: 'academics',
    title: '',
    keys: ['B66', 'B67', 'B68'],
    aggregateCount: true,
  },
];
